import React from "react"
import { Button, Grid, Typography } from "@material-ui/core"

import InputBlockMessage from "@/pages/Attendance/Chat/ConversationPanel/Input/InputBlockMessage"

import WABAMessageTemplateSelector, { WABAMessageTemplateSelectorProps } from "@/@integrations/WABA/components/Chat/WABAMessageTemplate/WABAMessageTemplateSelector"

import useStyles from "@/@integrations/WABA/components/Chat/WABAInputBlockMessage/styles"
import { IChatClient } from "@/protocols/channel"

export type WABAInputBlockMessageProps = {
	blocked: boolean
	client?: IChatClient
	WABAMessageTemplateSelectorProps: WABAMessageTemplateSelectorProps
}

const WABAInputBlockMessage: React.FC<WABAInputBlockMessageProps> = (props) => {
	const classes = useStyles()

	const wabaContact = props.client?.contacts?.find(contact => contact.channel_type === "waba")
	const isContactBlocked = wabaContact?.data.is_blocked ?? false

	return (
		<InputBlockMessage
			blocked={props.blocked}>
			<Grid
				container
				alignItems="center"
				justifyContent="space-between">
				{isContactBlocked ? (
					<Grid item>
						<Typography
							variant="body1"
							color="textPrimary"
							align="left">
							Esse contato está bloqueado.
						</Typography>
					</Grid>
				) : (
					<Grid
						container
						alignItems="center"
						justifyContent="space-between">
						<Grid item>
							<Typography
								variant="body1"
								color="textPrimary"
								align="left">
								Para iniciar uma conversa, você precisa enviar um template para o contato.
							</Typography>
						</Grid>

						<Grid item>
							<WABAMessageTemplateSelector {...props.WABAMessageTemplateSelectorProps}>
								<Button
									variant="contained"
									color="primary"
									className={classes.button}
								>
									Enviar template
								</Button>
							</WABAMessageTemplateSelector>
						</Grid>
					</Grid>
				)}
			</Grid>
		</InputBlockMessage>
	)
}

export default WABAInputBlockMessage
